import React, { Component } from 'react';

export class ErrorMessage extends Component {

  static style = {
    width: '320px',
    minHeight: '80px',
    display: 'flex',
    padding: '24px',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'solid red 1px',
    background: 'white',
    color: 'red',
    fontWeight: '400',
    boxShadow: '0 2px 2px 0 rgba(255,0,0,.14), 0 3px 1px -2px rgba(255,0,0,.2), 0 1px 5px 0 rgba(255,0,0,.12)',
  }

  render() {
    const styles = { ...ErrorMessage.style, ...this.props.overrideStyles};
    const isErrorGeneric = this.props.message === 'GENERIC_ERROR';

    return (
      <div style={styles}>
        {
          !isErrorGeneric ? this.props.message : <div>
            <p>Something terrible has happened, sorry for that!</p>
            <p>Please contact us via email <b>contact@vote-chain.com</b> and send some details. We will investigate this issue!</p>
            <p><b>If the problem is on our side we will transfer you some VETs</b> for helping us improving VoteChain!</p>
          </div>
        }
      </div>
    );
  }
};
